import React, { useState } from 'react';
import PropTypes from 'prop-types';

import FeedbackForm from './FeedbackForm'
import styles from './../style/WhyWeBest.module.scss';

const WhyWeBest = ({ backgroundImage = "img/why.jpg" }) => {
  const [showFeedback, setShowFeedback] = useState(false);
  const [formTitle, setFormTitle] = useState('');

  const handleFormSelect = (title) => {
    setFormTitle(title);
    setShowFeedback(true);
  };

  const closeFeedback = () => {
    setShowFeedback(false);
  };

  return (
    <>
      <div 
        className={`${styles.pr} d-none d-lg-block`} 
        style={{
          width: '100%', 
          height: '953px', 
          background: `url(${backgroundImage}) center top no-repeat`,
          marginBottom: '50px'
        }}
      >
        {/* Кликабельная область для выбора формы окна */}
        <div 
          style={{
            bottom: '0px', 
            width: '800px', 
            left: '50%', 
            height: '200px', 
            marginLeft: '-400px', 
            zIndex: '3333', 
            position: 'absolute', 
            cursor: 'pointer'
          }} 
          onClick={() => handleFormSelect('Подобрать форму окна')}
          role="button"
          tabIndex={0}
          onKeyPress={(e) => e.key === 'Enter' && handleFormSelect('Подобрать форму окна')}
          aria-label="Подобрать форму окна"
        />
        
        <div className={`${styles.wrap} ${styles.pr} ${styles.snn_mark}`}>
          <div className={styles.clear} style={{height: '80px'}} />
          
          <h2 className={`${styles.tac} ${styles.pb10} ${styles.fs15} ${styles.op07}`}>
            МЫ ИСПОЛЬЗУЕМ ЛУЧШИЕ КОМПЛЕКТУЮЩИЕ В НАШИХ 
          </h2>
          
          <h1 className={styles.mainTitle}>ДЕРЕВЯННЫХ ЕВРООКНАХ</h1>
          <div className={styles.h1_bot_2} />
          
          <div className={styles.clear} style={{height: '120px'}} />
          
          {/* Первая пара блоков */}
          <div className={styles.featureRow}>
            <div className={styles.featureBlockLeft}>
              <h2 className={`${styles.pb10} ${styles.fs24}`}>
                Экологичная <br /> и стойкая краска
              </h2>
              <div className={styles.h1_bot} style={{float: 'right'}} />
              <div className={styles.clear} style={{height: '20px'}} />
              <p className={styles.featureText}>
                Чистые красители на водной основе с сохранением дышащих способностей дерева от компаний:
                <br />Sikkens, Remmers, Zobel.
              </p>
            </div>
            
            <div className={styles.featureBlockRight}>
              <h2 className={`${styles.pb10} ${styles.fs24}`}>
                3 слойный клееный брус собственного производства 
              </h2>
              <div className={styles.h1_bot} style={{float: 'left'}} />
              <div className={styles.clear} style={{height: '20px'}} />
              <p className={styles.featureText}>
                Собственное производство клееного бруса, высушенного до 8-12% влажности, 
                без сучков смолянистых карманов и изъянов древесины гарантирует, 
                что наши окна не расклеятся и не треснут после истечении гарантийного срока.
              </p>
            </div>
          </div>
          
          <div className={styles.clear} style={{height: '50px'}} />
          
          {/* Вторая пара блоков */}
          <div className={styles.featureRow}>
            <div className={styles.featureBlockLeft} style={{width: '300px'}}>
              <h2 className={`${styles.pb10} ${styles.fs24}`}>Теплый Стеклопакет</h2>
              <div className={styles.h1_bot} style={{float: 'right'}} />
              <div className={styles.clear} style={{height: '20px'}} />
              <p className={styles.featureText}>
                Мультифункциональное стеклопакет, который экономит деньги 
                на отоплении и кондиционировании помещения.
              </p>
            </div>
            
            <div className={styles.featureBlockRight}>
              <h2 className={`${styles.pb10} ${styles.fs24}`}>Фурнитура "МАСО"</h2>
              <div className={styles.h1_bot} style={{float: 'left'}} />
              <div className={styles.clear} style={{height: '20px'}} />
              <p className={styles.featureText}>
                Лучшая Австрийская противовзломная фурнитура с антикоррозийным покрытием 
                обеспечивает идеальную работу окон.
              </p>
            </div>
          </div>
        </div>
      </div>

      <FeedbackForm
        title={formTitle}
        text={`Свяжитесь с нами и мы оперативно проконсультируем вас`}
        btn={`Отправить`}
        data={[]}
        show={showFeedback}
        handleClose={closeFeedback}
      />
    </>
  );
};

WhyWeBest.propTypes = {
  backgroundImage: PropTypes.string
}

WhyWeBest.defaultProps = {
  backgroundImage: "/IOJKDfb_assets/images/whywebest/why.jpg"
}

export default WhyWeBest;